// extracted by mini-css-extract-plugin
module.exports = {"title":"rejectionReasonModal-module_title_3515c","text":"rejectionReasonModal-module_text_5679b","date":"rejectionReasonModal-module_date_5d48c"};